export const localize = {
  en: {
    submit: 'Submit on WhatsApp',
    required: 'This field is required',
    disabled:
      'Sorry, we are currently not accepting responses. Please check back later.',
    other: 'Other',
    question: 'Question',
    validationFail: 'Please fill all required fields',
    somethingWrong: 'Oops! Something went wrong.',
    branding: 'A WhatsApp form created using',
    emailValidation: 'Please enter a valid email address',
    phoneValidation: 'Please enter a valid phone number',
    clickToUpload: 'Click to upload',
    fileUploadError: "Sorry, couldn't upload the file",
    fileUploadLimit: "Sorry, couldn't upload. File size exceeds 10 MB",
    pdfTypeError: 'Sorry, only PDF files can be uploaded',
    imageTypeError: 'Sorry, only image files can be uploaded',
    videoTypeError: 'Sorry, only video files can be uploaded',
    somethingNotRight: 'Oh no! Somethings not right.',
    formNotWorkingProperlyError:
      'Looks like this form is not working properly. Please contact the form owner.',
    response: 'Response',
    section: 'Section',
    referenceNo: 'Reference No',
    submitTextAppend: 'on WhatsApp',
    proceedToPayment: 'Proceed to Payment',
    messageOwner: 'Message Owner'
  },
  'pt-br': {
    submit: 'Enviar no WhatsApp',
    required: 'Este campo é obrigatório',
    disabled:
      'Desculpe, no momento não estamos aceitando respostas. Por favor, volte mais tarde.',
    other: 'Outro',
    question: 'Pergunta',
    validationFail: 'Por favor, preencha todos os campos obrigatórios',
    somethingWrong: 'Ops! Algo deu errado.',
    branding: 'Um formulário WhatsApp criado usando',
    emailValidation: 'Por favor insira um endereço de e-mail válido',
    phoneValidation: 'Por favor insira um número de telefone válido',
    clickToUpload: 'Clique para carregar',
    fileUploadError: 'Desculpe, não foi possível fazer upload do arquivo',
    fileUploadLimit:
      'Desculpe, não foi possível fazer o upload. O tamanho do arquivo excede 10 MB',
    pdfTypeError: 'Desculpe, apenas os arquivos PDF podem ser carregados',
    imageTypeError: 'Desculpe, apenas arquivos de imagem podem ser carregados',
    videoTypeError: 'Desculpe, apenas arquivos de vídeo podem ser carregados',
    somethingNotRight: 'Oh não! Algo não está certo.',
    formNotWorkingProperlyError:
      'Parece que este formulário não está funcionando corretamente. Por favor, entre em contato com o proprietário do formulário.',
    response: 'Resposta',
    section: 'Seção',
    referenceNo: 'Referência No',
    submitTextAppend: 'No WhatsApp',
    proceedToPayment: 'Prossiga para o pagamento',
    messageOwner: 'Mensagem ao Proprietário'
  },
  id: {
    submit: 'Kirim di WhatsApp',
    required: 'Bagian ini diperlukan',
    disabled:
      'Maaf, saat ini kami tidak menerima tanggapan. Silakan periksa kembali nanti.',
    other: 'Lainnya',
    question: 'Pertanyaan',
    validationFail: 'Harap isi semua bidang yang wajib diisi',
    somethingWrong: 'Ups! Ada yang salah.',
    branding: 'Formulir WhatsApp dibuat menggunakan',
    emailValidation: 'silakan isi alamat email',
    phoneValidation: 'silahkan masukkan nomor telepon yang benar',
    clickToUpload: 'Klik untuk mengunggah',
    fileUploadError: 'Maaf, tidak dapat mengunggah file',
    fileUploadLimit: 'Maaf, tidak dapat mengunggah. Ukuran file melebihi 10 MB',
    pdfTypeError: 'Maaf, hanya file PDF yang dapat diunggah',
    imageTypeError: 'Maaf, hanya file gambar yang dapat diunggah',
    videoTypeError: 'Maaf, hanya file video yang dapat diunggah',
    somethingNotRight: 'Oh tidak! Ada yang tidak beres.',
    formNotWorkingProperlyError:
      'Sepertinya formulir ini tidak berfungsi dengan baik. Silakan hubungi pemilik formulir.',
    response: 'Tanggapan',
    section: 'Bagian',
    referenceNo: 'Nomor Referensi',
    submitTextAppend: 'di WhatsApp',
    proceedToPayment: 'Lanjutkan ke Pembayaran',
    messageOwner: 'Pesan Pemilik'
  },
  es: {
    submit: 'Enviar en WhatsApp',
    required: 'Este campo es obligatorio',
    disabled:
      'Lo sentimos, actualmente no aceptamos respuestas. Por favor, vuelva más tarde.',
    other: 'Otro',
    question: 'Pregunta',
    validationFail: 'por favor llene todos los campos requeridos',
    somethingWrong: '¡UPS! Algo salió mal.',
    branding: 'Un formulario de WhatsApp creado con',
    emailValidation:
      'Por favor, introduce una dirección de correo electrónico válida',
    phoneValidation: 'Por favor ingrese un número de teléfono válido',
    clickToUpload: 'Haga clic para cargar',
    fileUploadError: 'Lo siento, no pude subir el archivo.',
    fileUploadLimit:
      'Lo siento, no se pudo cargar. El tamaño del archivo supera los 10 MB',
    pdfTypeError: 'Lo sentimos, solo se pueden cargar archivos PDF',
    imageTypeError: 'Lo sentimos, solo se pueden cargar archivos de imagen',
    videoTypeError: 'Lo sentimos, solo se pueden cargar archivos de video',
    somethingNotRight: '¡Oh no! Algo no está bien.',
    formNotWorkingProperlyError:
      'Parece que este formulario no está funcionando correctamente. Por favor, póngase en contacto con el propietario del formulario.',
    response: 'Respuesta',
    section: 'Sección',
    referenceNo: 'No. de referencia',
    submitTextAppend: 'En WhatsApp',
    proceedToPayment: 'Proceder al pago',
    messageOwner: 'Mensaje al Propietario'
  },
  fr: {
    submit: 'Envoyer sur WhatsApp',
    required: 'Ce champ est obligatoire',
    disabled:
      "Désolé, nous n'acceptons actuellement pas de réponses. Veuillez revenir plus tard.",
    other: 'Autre',
    question: 'Question',
    validationFail: 'Veuillez remplir tous les champs obligatoires',
    somethingWrong: `Oups! Quelque chose s'est mal passé.`,
    branding: "Un formulaire WhatsApp créé à l'aide",
    emailValidation: `S'il vous plaît, mettez une adresse email valide`,
    phoneValidation: `s'il vous plaît entrer un numéro de téléphone valide`,
    clickToUpload: 'Cliquez pour télécharger',
    fileUploadError: 'Désolé, impossible de télécharger le fichier',
    fileUploadLimit:
      'Désolé, impossible de télécharger. La taille du fichier dépasse 10 Mo',
    pdfTypeError: 'Désolé, seuls les fichiers PDF peuvent être téléchargés',
    imageTypeError: 'Désolé, seuls les fichiers image peuvent être téléchargés',
    videoTypeError: 'Désolé, seuls les fichiers vidéo peuvent être téléchargés',
    somethingNotRight: 'Oh non! Quelque chose ne va pas.',
    formNotWorkingProperlyError: `Il semble que ce formulaire ne fonctionne pas correctement. Veuillez contacter le propriétaire du formulaire.`,
    response: 'Réponse',
    section: 'Section',
    referenceNo: 'Référence No',
    submitTextAppend: 'sur WhatsApp',
    proceedToPayment: 'Procéder au paiement',
    messageOwner: 'Message au propriétaire'
  },
  it: {
    submit: 'Invia su WhatsApp',
    required: 'Questo campo è obbligatorio',
    disabled:
      'Siamo spiacenti, al momento non accettiamo risposte. Per favore controllare più tardi.',
    other: 'Altro',
    question: 'Domanda',
    validationFail: 'Si prega di compilare tutti i campi richiesti',
    somethingWrong: 'Ops! Qualcosa è andato storto.',
    branding: 'Un modulo WhatsApp creato utilizzando',
    emailValidation: 'Si prega di inserire un indirizzo email valido',
    phoneValidation: 'Si prega di inserire un numero di telefono valido',
    clickToUpload: 'Fare clic per caricare',
    fileUploadError: 'Spiacenti, impossibile caricare il file',
    fileUploadLimit:
      'Spiacenti, impossibile caricare. La dimensione del file supera i 10 MB',
    pdfTypeError: 'Spiacenti, è possibile caricare solo file PDF',
    imageTypeError: 'Spiacenti, è possibile caricare solo file di immagine',
    videoTypeError: 'Spiacenti, è possibile caricare solo file video',
    somethingNotRight: 'Oh no! Qualcosa non va.',
    formNotWorkingProperlyError: `Sembra che questo modulo non funzioni correttamente. Si prega di contattare il proprietario del modulo.`,
    response: 'Risposta',
    section: 'Sezione',
    referenceNo: 'No. di riferimento',
    submitTextAppend: 'su WhatsApp',
    proceedToPayment: 'Procedi al pagamento',
    messageOwner: 'Messaggio al proprietario'
  },
  de: {
    submit: 'Auf WhatsApp senden',
    required: 'Dieses Feld ist erforderlich',
    disabled:
      'Leider akzeptieren wir derzeit keine Antworten. Bitte schauen Sie später noch einmal vorbei.',
    other: 'Andere',
    question: 'Frage',
    validationFail: 'Bitte füllen Sie alle Pflichtfelder aus',
    somethingWrong: 'Hoppla! Etwas ist schief gelaufen.',
    branding: 'Ein WhatsApp-Formular erstellt mit',
    emailValidation: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    phoneValidation: 'Bitte geben Sie eine gültige Telefonnummer ein',
    clickToUpload: 'Klicken Sie zum Hochladen',
    fileUploadError: 'Entschuldigung, konnte Datei nicht hochladen',
    fileUploadLimit:
      'Entschuldigung, konnte nicht hochladen. Dateigröße überschreitet 10 MB',
    pdfTypeError: 'Entschuldigung, nur PDF-Dateien können hochgeladen werden',
    imageTypeError: 'Entschuldigung, nur Bilddateien können hochgeladen werden',
    videoTypeError:
      'Entschuldigung, nur Videodateien können hochgeladen werden',
    somethingNotRight: 'Oh nein! Etwas stimmt nicht.',
    formNotWorkingProperlyError: `Es scheint, dass dieses Formular nicht richtig funktioniert. Bitte kontaktieren Sie den Formularbesitzer.`,
    response: 'Antwort',
    section: 'Abschnitt',
    referenceNo: 'Referenz-Nr.',
    submitTextAppend: 'auf WhatsApp',
    proceedToPayment: 'Zur Zahlung gehen',
    messageOwner: 'Nachricht an den Besitzer'
  },
  zh: {
    submit: '在WhatsApp上提交',
    required: '此字段是必需的',
    disabled: '抱歉，我们目前不接受回复。 请稍后再回来查看。',
    other: '其他',
    question: '题',
    validationFail: '请填写所有必填字段',
    somethingWrong: '行动！出问题了。',
    branding: '使用创建的 WhatsApp 表单',
    emailValidation: '请输入有效的电子邮件地址',
    phoneValidation: '请输入一个有效的电话号码',
    clickToUpload: '点击上传',
    fileUploadError: '抱歉，无法上传文件',
    fileUploadLimit: '抱歉，无法上传。文件大小超过 10 MB',
    pdfTypeError: '抱歉，只能上传 PDF 文件',
    imageTypeError: '抱歉，只能上传图片文件',
    videoTypeError: '抱歉，只能上传视频文件',
    somethingNotRight: '哦不！出了点问题。',
    formNotWorkingProperlyError: `看起来这个表单没有正常工作。 请联系表单所有者。`,
    response: '回复',
    section: '部分',
    referenceNo: '参考编号',
    submitTextAppend: '在 WhatsApp',
    proceedToPayment: '继续付款',
    messageOwner: '消息所有者'
  },
  ru: {
    submit: 'Отправить в WhatsApp',
    required: 'Это поле обязательно к заполнению',
    disabled:
      'Извините, в настоящее время мы не принимаем ответы. Пожалуйста, зайдите позже.',
    other: 'Другой',
    question: 'Вопрос',
    validationFail: 'Пожалуйста, заполните все обязательные поля',
    somethingWrong: 'Ой! Что-то пошло не так.',
    branding: 'Форма WhatsApp, созданная с использованием',
    emailValidation:
      'Пожалуйста, введите действительный адрес электронной почты',
    phoneValidation: 'Пожалуйста, введите действующий телефонный номер',
    clickToUpload: 'Нажмите, чтобы загрузить',
    fileUploadError: 'Извините, не удалось загрузить файл',
    fileUploadLimit:
      'Извините, не удалось загрузить. Размер файла превышает 10 МБ.',
    pdfTypeError: 'Извините, можно загружать только PDF-файлы',
    imageTypeError: 'Извините, можно загружать только файлы изображений',
    videoTypeError: 'Извините, можно загружать только видеофайлы',
    somethingNotRight: 'Ой! Что-то не так.',
    formNotWorkingProperlyError: `Похоже, что эта форма работает неправильно. Пожалуйста, свяжитесь с владельцем формы.`,
    response: 'Ответ',
    section: 'Раздел',
    referenceNo: 'Номер справки',
    submitTextAppend: 'в WhatsApp',
    proceedToPayment: 'Перейти к оплате',
    messageOwner: 'Сообщение владельцу'
  },
  ar: {
    submit: 'إرسال على الواتساب',
    required: 'هذا الحقل مطلوب',
    disabled: 'عذرا، نحن لا نقبل ردود حاليا. يرجى التحقق مرة أخرى في وقت لاحق.',
    other: 'آخر',
    question: 'سؤال',
    validationFail: 'يرجى ملء جميع الحقول المطلوبة',
    somethingWrong: 'عفوا! حدث خطأ ما.',
    branding: 'نموذج WhatsApp تم إنشاؤه باستخدام',
    emailValidation: 'الرجاء إدخال عنوان بريد إلكتروني صالح',
    phoneValidation: 'الرجاء إدخال رقم هاتف صالح',
    clickToUpload: 'انقر لتحميل',
    fileUploadError: 'عذرًا ، لم يتمكن من تحميل الملف',
    fileUploadLimit:
      'عذرًا ، لم يتمكن من التحميل. يتجاوز حجم الملف 10 ميجا بايت',
    pdfTypeError: 'عذرًا ، يمكن تحميل ملفات PDF فقط',
    imageTypeError: 'عذرًا ، يمكن تحميل ملفات الصور فقط',
    videoTypeError: 'عذرًا ، يمكن تحميل ملفات الفيديو فقط',
    somethingNotRight: 'أوه لا! شيء ما ليس على ما يرام.',
    formNotWorkingProperlyError: `يبدو أن هذا النموذج لا يعمل بشكل صحيح. يرجى الاتصال بمالك النموذج.`,
    response: 'إجابة',
    section: 'قسم',
    referenceNo: 'المرجع رقم',
    submitTextAppend: 'على الواتساب',
    proceedToPayment: 'المتابعة إلى الدفع',
    messageOwner: 'رسالة إلى المالك'
  }
};
